const PolicyStep4Icon = ({ size = 64, className = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <foreignObject x="-9" y="-9" width="82" height="82">
        <div xmlns="http://www.w3.org/1999/xhtml" style={{backdropFilter: 'blur(4.5px)', clipPath: 'url(#bgblur_0_1762_108323_clip_path)', height: '100%', width: '100%'}}></div>
      </foreignObject>
      <rect data-figma-bg-blur-radius="9" width="64" height="64" rx="32" fill="url(#paint0_linear_1762_108323)" fillOpacity="0.14"/>
      <foreignObject x="3.44531" y="1.5" width="56.6406" height="61">
        <div xmlns="http://www.w3.org/1999/xhtml" style={{backdropFilter: 'blur(8.25px)', clipPath: 'url(#bgblur_1_1762_108323_clip_path)', height: '100%', width: '100%'}}></div>
      </foreignObject>
      <g filter="url(#filter1_d_1762_108323)" data-figma-bg-blur-radius="16.5">
        <path d="M33.0266 46V41.08H19.9466V35.92L32.1866 18H39.1066V35.6H43.5866V41.08H39.1066V46H33.0266ZM26.3866 35.6H33.0266V25.88L26.3866 35.6Z" fill="url(#paint1_linear_1762_108323)"/>
      </g>
      <rect x="1" y="1" width="62" height="62" rx="31" stroke="url(#paint2_linear_1762_108323)" strokeOpacity="0.6" strokeWidth="2"/>
      <defs>
        <clipPath id="bgblur_0_1762_108323_clip_path" transform="translate(9 9)">
          <rect width="64" height="64" rx="32"/>
        </clipPath>
        <filter id="filter1_d_1762_108323" x="3.44531" y="1.5" width="56.6406" height="61" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation="3.50204"/>
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.27 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1762_108323"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1762_108323" result="shape"/>
        </filter>
        <clipPath id="bgblur_1_1762_108323_clip_path" transform="translate(-3.44531 -1.5)">
          <path d="M33.0266 46V41.08H19.9466V35.92L32.1866 18H39.1066V35.6H43.5866V41.08H39.1066V46H33.0266ZM26.3866 35.6H33.0266V25.88L26.3866 35.6Z"/>
        </clipPath>
        <linearGradient id="paint0_linear_1762_108323" x1="6.84871" y1="5.90477" x2="77.0945" y2="29.7546" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0.9"/>
          <stop offset="0.447036" stopColor="white" stopOpacity="0.955296"/>
          <stop offset="1" stopColor="white" stopOpacity="0.9"/>
        </linearGradient>
        <linearGradient id="paint1_linear_1762_108323" x1="25" y1="17" x2="38.3715" y2="16.6922" gradientUnits="userSpaceOnUse">
          <stop stopColor="#ABABAB"/>
          <stop offset="1" stopColor="white"/>
        </linearGradient>
        <linearGradient id="paint2_linear_1762_108323" x1="9.21033" y1="-2.28571" x2="69.1996" y2="32.7399" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0.1"/>
          <stop offset="0.473958" stopColor="white"/>
          <stop offset="1" stopColor="white" stopOpacity="0.09"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PolicyStep4Icon; 